import db from "@/plugins/dexie";
import api from '@/services/api-varejoweb';
import geraData from "../geradata";


export default async function $_enviaImagem(idParentLocal = null) {
  let imagens = await db.imagem.toArray();
  imagens = imagens.filter(i => !i.datanuvem);

  if (idParentLocal) {
    const parentOS = await db.prestacaoservico.get(idParentLocal);
    let itemLocalIds = [];
    if (parentOS) {
      const items = await db.prestacaoservicoitem.filter(i => 
        i.idprestacaoservico === idParentLocal ||
        (parentOS.prslinkpedidoitem && i.prilinkpedidoitem === parentOS.prslinkpedidoitem) ||
        (parentOS.prsidnuvem && i.priidprestacaoserviconuvem && String(i.priidprestacaoserviconuvem) === String(parentOS.prsidnuvem))
      ).toArray();
      itemLocalIds = items.map(i => i.id);
    }
    
    imagens = imagens.filter(img => {
      const isParentOSImage = img.relacao === 'prestacaoservico' && img.relacaoidlocal === idParentLocal;
      const isItemImage = img.relacao === 'prestacaoservicoitem' && itemLocalIds.includes(img.relacaoidlocal);
      return isParentOSImage || isItemImage;
    });
  }

  console.log('imagens', imagens);
  const parentCache = {};

  // Cria um array de Promises
  const promises = imagens.map(async (item) => {

    if (item.tentativa >= 3) {
      await db.imagem.where({id: item.id}).delete();
      return;
    }    

    const cacheKey = `${item.relacao}_${item.relacaoidlocal}`;
    let parent = parentCache[cacheKey];

    if (!parent) {
      if (item.relacao === 'ordemservicoitem') {
        parent = await db.ordemservicoitem.get(item.relacaoidlocal);
      } else if (item.relacao === 'prestacaoservico') {
        parent = await db.prestacaoservico.get(item.relacaoidlocal);
      } else if (item.relacao === 'prestacaoservicoitem') {
        parent = await db.prestacaoservicoitem.get(item.relacaoidlocal);
      }
      if (parent) {
        parentCache[cacheKey] = parent;
      }
    }

    if (!parent) return;

    let idNuvem;
    if (item.relacao === 'ordemservicoitem') idNuvem = parent.osiidnuvem;
    else if (item.relacao === 'prestacaoservico') idNuvem = parent.prsidnuvem;
    else if (item.relacao === 'prestacaoservicoitem') idNuvem = parent.priidnuvem;

    if (!idNuvem) return;

    const nomeCompleto = item.nomearquivo.split("|");

    // substitui apenas o índice 1 (o segundo valor)
    nomeCompleto[1] = idNuvem;

    // remonta a string com a mesma estrutura
    const resultado = nomeCompleto.join("|");

    console.log('item nome arquivo', item.nomearquivo);
    console.log('resultado', resultado);

    const formData = new FormData();
    formData.append('image', item.blob, resultado);

    let rota = item.rotaapi;
    if (rota === '/imagem/prestacaoservico') {
      rota = '/imagem/ordemservico';
      await db.imagem.update(item.id, { rotaapi: rota });
    }

    let res;
    try {
      res = await api.post(rota, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

    } catch (err) {
      console.log(err);
      await db.imagem.update(item.id, {
        tentativa: item.tentativa + 1,
      });
    }

    if (res) {
      console.log('Imagem enviada: ', res)
      await db.imagem.update(item.id, {
        datanuvem: geraData(),
      });
    }

  });

  // Aguarda todas as requisições terminarem
  await Promise.all(promises);

}
